import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "backgroundColor", "textColor"];
import React from 'react';
import PropTypes from 'prop-types';

var TextCircleIcon = function TextCircleIcon(_ref) {
  var text = _ref.text,
      backgroundColor = _ref.backgroundColor,
      textColor = _ref.textColor,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/React.createElement("title", null, text), /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "31",
    r: "30",
    fill: backgroundColor
  }), /*#__PURE__*/React.createElement("text", {
    x: "30",
    y: "30",
    textAnchor: "middle",
    alignmentBaseline: "central",
    fill: textColor,
    stroke: textColor
  }, text));
};

TextCircleIcon.displayName = 'TextCircleIcon';
TextCircleIcon.propTypes = {
  text: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string
};
TextCircleIcon.defaultProps = {
  text: 'Offers',
  backgroundColor: 'red',
  textColor: 'white'
};
export default TextCircleIcon;